import React from "react";

export interface ScheduleWindow {
  daysOfWeek: string[];
  fromTime: string;
  toTime: string;
}

export interface SharedSchedule {
  id: number;
  name: string;
  timezone: string | null;
  windows: ScheduleWindow[];
}

export const SharedSchedulesContext = React.createContext<{
  schedules: SharedSchedule[];
  loading: boolean;
  reload: () => void;
}>({
  schedules: [],
  loading: true,
  reload: () => {}
});
